import {getSimpleUserList} from "@/utils/general/getUserInfo";

const state = () => ({
  // 个人用户部分
  userID:'', //用户ID
  userName:'',//用户名
  access_token:'', //当前用户的token（即Web端的用户token）
  userInfo:'', // 当前用户的基本信息
  userProfile:'', // 携带有用户岗位信息的用户信息
  // 单位部门部分
  deptTree:'', // 单位组织架构信息
  deptUsersList:'', // 指定部门下的人员信息
  simpleUserList:'', // 简化的部门人员信息：[{ userId: "1978711864507097090", nickName: "费兴"}....]形式
})
const getters = {}
const mutations = {
  setUserID(state,value){
    state.userID = value
  },
  setToken(state,value){
    state.access_token = value
  },
  setUserName(state,value){
    state.userName = value
  },
  setUserInfo(state,value){
    state.userInfo = value
  },
  setUserProfile(state,value){
    state.userProfile = value
  },
  setDeptTree(state,value){
    state.deptTree = value
  },
  setDeptUsersList(state,value){
    state.deptUsersList = value
  },
  setSimpleUserList(state,value){
    state.simpleUserList = value
  },
}
export default {
  namespaced: true,
  state,
  getters,
  mutations
}
